import type { ReactNode } from 'react'

import { cn } from '@/utils/cn'
import { KzEmpty } from '../kz-empty/KzEmpty'

export type IsLoadingProps = {
    isLoading: boolean
    iconClassName?: string
    empty?: boolean
    emptyMessage?: string
    emptyIcon?: ReactNode
    message?: string
    centered?: boolean
    children?: ReactNode
    animate?: boolean
}

export const IsLoading = ({
    isLoading,
    empty,
    emptyMessage,
    emptyIcon,
    message,
    centered,
    children,
    iconClassName,
    animate = true,
}: IsLoadingProps) => {
    if (!isLoading && !empty) return children

    return (
        <div className={cn('animate-opacity-3 text-primary text-center select-none', centered && 'absolute-center')}>
            {isLoading ? (
                <Loader message={message} iconClassName={iconClassName} animate={animate} />
            ) : (
                <KzEmpty description={emptyMessage} icon={emptyIcon} animate={animate} />
            )}
        </div>
    )
}

const Loader = ({
    message,
    iconClassName,
    animate,
}: {
    message?: string
    iconClassName?: string
    animate?: boolean
}) => {
    return (
        <>
            <div
                className={cn('text-primary mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-b-2', iconClassName)}
            />
            <p className={cn('text-primary text-sm opacity-70', animate && 'animate-pulse')}>{message}</p>
        </>
    )
}
